export default __webpack_public_path__ + "static/media/playstore_logo.76f13042.png";